import { render } from "./itemImages.vue?vue&type=template&id=eff21b54"
import script from "./itemImages.vue?vue&type=script&lang=js"
export * from "./itemImages.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__